import { FunctionComponent } from "react";
import { Tooltip } from "@mui/material";
import { WarningAmber } from "@mui/icons-material";
import { NavigationLink } from "components/navigation";
import { useProjectErrors } from "hooks/useProjectErrors";
import styles from "./ErrorIndicator.module.css";

interface ErrorIndicatorProps {
  projectId: string;
}

/**
 * Warning icon shown for a selected project, linking to its Post Submit Target
 * error list. Reads its count from ProjectErrorsProvider (mounted once per
 * project in ProjectLayout) so every instance of this indicator for the same
 * project always shows the same, synced value.
 */
export const ErrorIndicator: FunctionComponent<ErrorIndicatorProps> = ({ projectId }) => {
  const { count } = useProjectErrors();

  const hasErrors = count > 0;
  const label = hasErrors
    ? `${count} Post Submit Target Error${count === 1 ? "" : "s"}`
    : "No Post Submit Target errors";

  return (
    <Tooltip title={label}>
      <NavigationLink to={`/${projectId}/errors`} className={styles.indicator} aria-label={label}>
        <WarningAmber className={hasErrors ? styles.hasErrors : styles.noErrors} />
      </NavigationLink>
    </Tooltip>
  );
};
